import { Component, ViewChild } from '@angular/core';
import { ListComponent } from 'src/app/common/component/list.component';
import { ResidentTripListFilterComponent } from './resident-trip-list-filter/resident-trip-list-filter.component';

@Component({
	selector: 'app-resident-trip-list',
	templateUrl: './resident-trip-list.component.html',
	styleUrls: ['./resident-trip-list.component.css'],
})
export class ResidentTripListComponent extends ListComponent {
	@ViewChild(ResidentTripListFilterComponent)
	ResidentTripListFilterComponent: ResidentTripListFilterComponent;
	protected itemsBeforeDataLoad = 2;
	protected apiUrl = 'resident/residentTrips';
	filters;
	parameters = {
		destinations: [],
		trips: [],
	};

	protected loadBefore() {
		this.api.get('/bag/bagLocations/', (result, error) => {
			this.parameters.destinations = result.data.filter((obj) => ['11', '12', '143', '144'].includes(obj.id));
		});
		this.api.get('/resident/residentBaseTrips', (result, error) => {
			this.parameters.trips = result.data;
			this.loadData();
		});
	}

	tableRows = [
		{ id: 'destinations', name: 'Destynacja' },
		{ id: 'name', name: 'Wycieczka' },
		{ id: 'date', name: 'Data' },
		{ id: 'contigent', name: 'Ilość Miejsc' },
		{ id: 'freePlaces', name: 'Wolne' },
	];

	protected convertData(data) {
		data.forEach((obj) => {
			obj.destinations = obj.destinations.map((item) => item.name);
		});
		return data;
	}
}
